import React, { useEffect, useMemo, useState } from "react";
import styles from "./Sites.module.scss";
import { ToastContainer } from "react-toastify";
import storeMenu from "../../../stores";
import {
  MRT_ColumnDef,
  MRT_ShowHideColumnsButton as MrtShowHideColumnsButton,
  MRT_ToggleDensePaddingButton as MrtToggleDensePaddingButton,
  MRT_ToggleFiltersButton as MrtToggleFiltersButton,
  MRT_ToggleFullScreenButton as MrtToggleFullScreenButton,
  MRT_ToggleGlobalFilterButton as MrtToggleGlobalFilterButton,
  MaterialReactTable,
} from "material-react-table";
import {
  BASE_URL,
  PPE_getApiSync,
  getValueFromLocalStorageFunc,
  handleLogOutGlobal_PPE,
  handleSwal,
  handleSwalResult,
  notify,
} from "../../../services/functions";

import Swal, { SweetAlertResult } from "sweetalert2";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Box, Button } from "@mui/material";

import {
  ControlPointRounded,
  DeleteForever,
  ModeEdit,
  Refresh,
} from "@mui/icons-material";

import ModalCreateMembers from "../../modal/CreateMembers/Index";
import ModalDetailMember from "./ModalDetailMember";
import { useNavigate } from "react-router-dom";

type Member = {
  name: string;
  description: string;
  name_head: string;
  id: number;
  id_head: number;
};

const ListMember = () => {
  const [showModal, setShowModal] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [modalTitle, setModalTitle] = useState("Create"); // title modal (eg. Create user)
  const [modalStatus, setModalStatus] = useState(""); // status modal (eg. create / edit)
  const [modalRow, setModalRow] = useState({}); // data parsing for edit
  const [modalLoader, setModalLoader] = useState(true);

  const [showProgressBars, setShowProgressBars] = useState(true);
  const [showSkeleton, setShowSkeleton] = useState(true);

  const [rowList, setRowList] = useState<Member[]>([]);
  const [selectedMemberId, setSelectedMemberId] = useState<number | null>(null);

  const [initialRender, setInitialRender] = useState(true);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });

  useEffect(() => {
    setTimeout(() => {
      setShowProgressBars(false);
      setShowSkeleton(false);
    }, 1000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      storeMenu.dispatch({ type: "titleicon", text: "Organization" });
      storeMenu.dispatch({
        type: "breadcrumbs",
        text: [
          { key: "Settings", value: "Setting" },
          { key: "Sites", value: "Organization" },
        ],
      });
    }, 100);
    //console.log(modalRow);
  }, [showModal, modalRow]);

  useEffect(() => {
    setTimeout(() => {
      getDataList();
    }, 150);
  }, []);

  useEffect(() => {
    if (!initialRender) {
      //console.log(JSON.stringify(pagination));
    } else {
      setInitialRender(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination]);

  let columns = useMemo<MRT_ColumnDef<Member>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Member Name",
        size: 250,
        Cell: ({ row }) => {
          const navigate = useNavigate();
          const [isHover, setIsHover] = React.useState(false);

          return (
            <div
              style={{
                color: isHover ? "blue" : "black",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/list/member/${row.original.id}`)}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              {row.original.name}
            </div>
          );
        },
      },

      {
        accessorKey: "description",
        header: "Description",
        size: 250,
      },
      {
        accessorKey: "id_head",
        header: "Head ID",
        size: 200,
      },
      {
        accessorKey: "name_head",
        header: "Head Name",
        size: 250,
      },
      {
        id: "actions",
        header: "Actions",
        size: 150,
        Cell: ({ row }) => (
          <div className="d-flex align-items-center gap-2">
            {/* <div
              className={`${styles["ppe-icon-actions"]} ${styles["edit"]}`}
              title="Edit"
              onClick={() => {
                toolbarButtonClick("Edit", "Edit", row);
              }}
            >
              <ModeEdit sx={{ fill: "mediumslateblue !important" }} />
            </div> */}

            <div
              title="Hapus"
              style={{ cursor: "pointer" }}
              onClick={() => {
                toolbarButtonClick("Delete", "Delete", row);
              }}
            >
              <DeleteForever sx={{ fill: "red !important" }} />
            </div>
          </div>
        ),
      },
    ],
    [],
  );

  // const getDataList = () => {
  //   setShowProgressBars(true);
  //   setShowSkeleton(true);

  //   const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
  //   console.log("🔐 Token used for API request List Member : ", token);

  //   PPE_getApiSync(
  //     `${BASE_URL}/v1/members/list?limit=1000&offset=0`,
  //     null,
  //     "application/json",
  //     "GET",
  //     token,
  //   ).then((response) => {
  //     console.log("Data List Member :", response);
  //     setTimeout(() => {
  //       setShowProgressBars(false);
  //       setShowSkeleton(false);
  //     }, 77);

  //     if (Array.isArray(response)) {
  //       setRowList(response);
  //     } else {
  //       notify("error", "Failed to fetch members.", "TOP_CENTER");
  //     }
  //   });
  // };

  const getDataList = () => {
    setShowProgressBars(true);
    setShowSkeleton(true);

    const token = getValueFromLocalStorageFunc("IOT_TOKEN") ?? "";
    const apiUrl = `${BASE_URL}/v1/members/list?limit=1000&offset=0`;

    // console.log(
    //   "🔐 Token used for API request Members:",
    //   token ? "Token exists" : "No token",
    // );
    // console.log("🌐 API URL:", apiUrl);

    if (!token || token.length < 10) {
      console.error("❌ Invalid or missing token");
      notify(
        "error",
        "Invalid or missing authentication token. Please login again.",
        "TOP_CENTER",
      );
      setShowProgressBars(false);
      setShowSkeleton(false);
      window.location.href = "/login";
      return;
    }

    PPE_getApiSync(apiUrl, null, "application/json", "GET", token)
      .then((response) => {
        setTimeout(() => {
          setShowProgressBars(false);
          setShowSkeleton(false);
        }, 77);

        // console.log("📥 Raw API Response:", response);
        // console.log("📥 Response type:", typeof response);
        // console.log("📥 Is Array:", Array.isArray(response));

        if (response && response.statusCode) {
          console.error("API Error:", response);

          if (response.statusCode === "403") {
            notify(
              "error",
              "Access denied. You don't have permission to view members.",
              "TOP_CENTER",
            );
          } else if (response.statusCode === "401") {
            notify(
              "error",
              "Authentication failed. Please login again.",
              "TOP_CENTER",
            );
            setTimeout(() => {
              window.location.href = "/login";
            }, 2000);
          } else {
            notify(
              "error",
              response.msg || "Failed to fetch members.",
              "TOP_CENTER",
            );
          }

          setRowList([]);
          return;
        }

        if (Array.isArray(response)) {
          // console.log(
          //   "✅ Members data loaded successfully:",
          //   response.length,
          //   "members"
          // );
          setRowList(response);
        } else {
          console.warn("⚠️ Unexpected response format:", response);
          notify(
            "error",
            "Failed to fetch members. Unexpected response format.",
            "TOP_CENTER",
          );
          setRowList([]);
        }
      })
      .catch((error) => {
        console.error("❌ API call failed:", error);
        setShowProgressBars(false);
        setShowSkeleton(false);
        notify(
          "error",
          "Network error. Please check your connection.",
          "TOP_CENTER",
        );

        handleLogOutGlobal_PPE();
        window.location.href = "/login";

        setRowList([]);
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const openModal = (id: number) => {
    setSelectedMemberId(id);
    setShowModalDetail(true);
  };

  const toolbarButtonClick = (
    status: "Create" | "Edit" | "Delete",
    title: string,
    row?: any,
  ) => {
    if (status === "Delete") {
      handleSwal(
        "Delete",
        row.original?.["name"],
        (resultSwal: SweetAlertResult) => {
          if (resultSwal.isConfirmed) {
            handleSwalResult(
              "isConfirmed",
              row.original?.["name"],
              {
                endpoint: `${BASE_URL}/v1/members/delete`,
                obj: { id: row.original?.["id"] },
                body_type: "application/json",
                method: "DELETE",
                token: getValueFromLocalStorageFunc("IOT_TOKEN"),
              },
              () => {
                //getDataList();
                setTimeout(() => {
                  notify(
                    "info",
                    "Please refresh the page if data is not updated.",
                    "TOP_CENTER",
                  ); // Notify after some delay if data not updated
                }, 2000);
              },
            );
          } else if (resultSwal.dismiss === Swal.DismissReason.cancel) {
            handleSwalResult("cancelled");
          }
        },
      );
    } else {
      setModalStatus(status);
      setModalTitle(title);
      setShowModal(true);
      setModalLoader(true);

      if (status === "Edit") {
        setTimeout(() => {
          setModalLoader(false);
          setModalRow(row.original);
        }, 500);
      } else if (status === "Create") {
        setTimeout(() => {
          setModalLoader(false);
          setModalRow({
            name: "",
            description: "",
            id_head: 1, // Default value, could be dynamic
            role: 2, // Default role, adjust as needed
          });
        }, 0);
      }
    }
  };

  // const handlePaginationChange = (newPage) => {
  //   console.log(newPage.pageSize);
  //   console.log(newPage.pageIndex);
  // };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MaterialReactTable
          columns={columns}
          data={rowList}
          // enableColumnPinning
          // manualPagination={true}  // record tidak berubah jika page berubah
          paginationDisplayMode="pages" // pages->tampilkan per nomor halaman (1,2,3,...)
          muiPaginationProps={{
            size: "medium",
            color: "primary",
            shape: "rounded",
            variant: "outlined",
            // showRowsPerPage:true, // [5,10,15,All] show or not
            rowsPerPageOptions: [
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 15, label: "15" },
              { value: rowList.length, label: "All" },
            ],
            // rowsPerPageOptions:[5,10,15],
            showFirstButton: true,
            showLastButton: true,
          }}
          onPaginationChange={setPagination} // harus set 'state -> pagination' juga
          // rowCount={100} //you can tell the pagination how many rows there are in your back-end data

          state={{
            pagination: pagination,
            showAlertBanner: false,
            showProgressBars: showProgressBars,
            showSkeletons: showSkeleton,
          }}
          // muiToolbarAlertBannerProps={{color:'error', children:'Network error'}}
          // positionToolbarAlertBanner='top'

          initialState={{
            // columnPinning:{left:['mrt-row-actions','mrt-row-numbers']},
            density: "comfortable", // tinggi setiap row (spacious, comfortable, compact)
            columnOrder: [
              "mrt-row-numbers",
              "full_name",
              "email",
              "is_active",
              "is_superuser",
              // 'mrt-row-actions',
            ],
            columnVisibility: { id: false, token_user: false },
          }}
          renderTopToolbarCustomActions={({ table }) => {
            const modalEventOutChange = ({ tipe, value, form }) => {
              if (form === "create") {
                if (tipe === "close_modal") {
                  // setShowModal(value);
                  setTimeout(() => {
                    setShowModal(value);
                  }, 5);
                } else if (tipe === "close_after_success_save") {
                  setShowModal(value);
                  getDataList();
                }
              }
            };

            return (
              <Box>
                <div className="d-flex gap-2 mb-2 mt-2 ms-2">
                  {
                    <Button
                      onClick={() => {
                        toolbarButtonClick("Create", "Create Site");
                      }}
                      variant="contained"
                      className="d-flex justify-content-between"
                      style={{
                        backgroundColor: "#008ea1",
                        paddingLeft: "5px",
                        paddingRight: "10px",
                      }}
                    >
                      <ControlPointRounded titleAccess="Create" />
                      <span className="ms-1" title="Create">
                        Create Member
                      </span>
                    </Button>
                  }

                  <Button
                    color="secondary"
                    onClick={() => {
                      getDataList();
                    }}
                    variant="outlined"
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      paddingLeft: "5px",
                      paddingRight: "5px",
                      minWidth: "0",
                    }}
                  >
                    <Refresh titleAccess="Refresh" />
                    {/* <span className='ms-1'>Refresh</span>  */}
                  </Button>
                </div>

                <ModalCreateMembers
                  par_show={showModal ?? false}
                  title={modalTitle}
                  status={modalStatus}
                  par_statusLoader={modalLoader}
                  row={modalRow}
                  outChange={modalEventOutChange}
                />
              </Box>
            );
          }}
          enableFacetedValues // untuk filterVariant = 'multi-select' hanya terambil data unik otomatis
          renderToolbarInternalActions={({ table }) => {
            return (
              <Box>
                {/* <IconButton onClick={()=>window.print()}>
                              <Print />
                            </IconButton> */}
                <MrtToggleGlobalFilterButton table={table} />
                <MrtToggleFiltersButton table={table} />
                <MrtShowHideColumnsButton table={table} />
                <MrtToggleDensePaddingButton table={table} />
                <MrtToggleFullScreenButton table={table} />
              </Box>
            );
          }}
          // custom if rows empty / kosong
          renderEmptyRowsFallback={({ table }) => {
            return (
              <p
                style={{
                  margin: 0,
                  fontFamily: '"Roboto", "Helvetica", "Arial",sans-serif',
                  fontStyle: "italic",
                  letterSpacing: "0.00938em",
                  width: "100%",
                  color: "rgba(0, 0, 0, 0.6)",
                  lineHeight: "1.5",
                  textAlign: "center",
                  paddingTop: "2rem",
                  paddingBottom: "2rem",
                  fontWeight: 400,
                }}
              >
                No records to display
              </p>
            );
          }}
          muiTableBodyProps={{
            // styling body data
            sx: {
              "& tr:nth-of-type(odd) > td": {
                backgroundColor: "aliceblue",
              },
            },
          }}
          muiTableBodyCellProps={{
            // styling semua cell dalam body data
            sx: {
              // borderRight:'1px solid #e0e0e0'
            },
          }}
          // enableRowSelection

          enableTopToolbar={true}
          muiTopToolbarProps={{
            // styling top Toolbar
            sx: {
              // background:'linear-gradient(45deg, darkcyan, white)'
              boxShadow: "0px 1px 12px -7px grey inset", // shadow inset toolbar di atas
              paddingTop: "7px",
              // borderBottom:'1px solid lightgrey'
            },
          }}
          muiTableHeadCellProps={{
            // styling head cell / nama column
            sx: {
              backgroundColor: "transparent",
              textAlign: "left",
              paddingTop: "10px",
              paddingBottom: "10px",
              display: "flex",
              justifyContent: "center",
            },
          }}
          columnFilterDisplayMode="subheader"
          enableColumnFilterModes
          enableColumnOrdering
          enableColumnResizing
          enableRowNumbers
          rowNumberDisplayMode="static"
          positionActionsColumn="first"
          displayColumnDefOptions={{
            "mrt-row-numbers": {
              visibleInShowHideMenu: true,
              enableHiding: true,
              Header: "No",
            },
            "mrt-row-actions": {
              header: "Actions",
              size: 100,
            },
          }}
          renderRowActions={({ cell, row, table }) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            let cellContent = row.original?.["name"]?.["firstName"];
            return (
              <div className="d-flex align-items-center gap-2">
                <div
                  className={`${styles["ppe-icon-actions"]} ${styles["edit"]}`}
                  title="Edit"
                  onClick={() => {
                    toolbarButtonClick("Edit", "Edit", row);
                  }}
                >
                  <ModeEdit sx={{ fill: "mediumslateblue !important" }} />
                </div>

                <div
                  title="Hapus"
                  onClick={() => {
                    toolbarButtonClick("Delete", "Delete", row);
                  }}
                >
                  <DeleteForever sx={{ fill: "red !important" }} />
                </div>
              </div>
            );
          }}
        />
        {selectedMemberId !== null && (
          <ModalDetailMember
            showModal={showModalDetail}
            memberId={selectedMemberId}
            onClose={() => setShowModalDetail(false)}
          />
        )}
      </LocalizationProvider>

      <ToastContainer draggable pauseOnHover />
      {/* <LocalizationProvider dateAdapter={AdapterDate}  */}
    </>
  );
};

export default ListMember;
